import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { H3_TITLE } from '@Apis/constants';
import QCPointList from './QCPointList';
import './style.scss';

/**
 *
 */
class QCPointHome extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <div className="org-wrapper">
          <QCPointList />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({
});

QCPointHome.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCPointHome));
